const resolve = (url, ...args) => {
  let newUrl = url
  if (args.length > 0) {
    args.forEach((arg, i) => {
      newUrl = newUrl.replace(`{${i}}`, arg)
    })
  }
  return newUrl
}

export default resolve
